import { CSSProperties } from 'react';
import { IconType } from '.';

interface PhotoSquareProps extends IconType {
  style?: CSSProperties;
}

export default function PhotoSquare({ className = '', color = '#fff', height = 60, style, width = 60 }: PhotoSquareProps) {
  return (
    <svg width={width} height={height} style={style} className={className} viewBox="0 0 60 60">
      <rect id="Rectangle_4845" data-name="Rectangle 4845" width="60" height="60" rx="8" opacity="0.539" />
      <path
        id="expand-solid-2"
        d="M2.321,32A2.319,2.319,0,0,0,0,34.321v6.964a2.321,2.321,0,0,0,4.643,0V36.643H9.285a2.321,2.321,0,1,0,0-4.643ZM4.643,55.214a2.321,2.321,0,0,0-4.643,0v6.964A2.319,2.319,0,0,0,2.321,64.5H9.285a2.321,2.321,0,1,0,0-4.643H4.643ZM23.214,32a2.321,2.321,0,1,0,0,4.643h4.643v4.643a2.321,2.321,0,0,0,4.643,0V34.321A2.319,2.319,0,0,0,30.178,32ZM32.5,55.214a2.321,2.321,0,0,0-4.643,0v4.643H23.214a2.321,2.321,0,1,0,0,4.643h6.964A2.319,2.319,0,0,0,32.5,62.178Z"
        transform="translate(13.25 -18.25)"
        fill="#fff"
      />
    </svg>
  );
}
